import { useCallback, useState, type ReactNode } from "react"
import { cn } from "@/lib/utils"
import { KpiStatRow, type KpiStatItem } from "../KpiStat/KpiStat"

export interface BacktestResultsView {
  id: string
  kpi: KpiStatItem
  content: ReactNode
}

export interface BacktestResultsProps {
  views: BacktestResultsView[]
  activeViewId?: string
  defaultViewId?: string
  onViewChange?: (id: string) => void
  className?: string
}

export function BacktestResults({
  views,
  activeViewId: controlled,
  defaultViewId,
  onViewChange,
  className,
}: BacktestResultsProps) {
  const [internal, setInternal] = useState<string>(
    defaultViewId ?? views[0]?.id ?? "",
  )
  const active = controlled ?? internal

  const handleSelect = useCallback(
    (id: string) => {
      setInternal(id)
      onViewChange?.(id)
    },
    [onViewChange],
  )

  const current = views.find((v) => v.id === active) ?? views[0]
  const kpiItems = views.map((v) => v.kpi)

  return (
    <div
      className={cn(
        "flex flex-col h-full overflow-y-auto bg-card",
        className,
      )}
    >
      <KpiStatRow
        items={kpiItems}
        activeId={current?.id ?? null}
        onSelect={handleSelect}
      />
      {current?.content}
    </div>
  )
}
